//缓存类
export default class Cache {
    constructor(options) {
        this.uid='';
    }
    makekey(url,params){
        var key=(url+JSON.stringify(params)).replace(/[\/:\",{}]/g,'');
        return key;
    }
    getkey(key,nowTime){
        let ukey='';
        if(!nowTime){//获取
            if(!key)throw new Error('请输入cache key!');
            ukey=key.length>45?md5(key):key;
        }else{//写入（key可以为空）
            ukey=!key?'cache'+nowTime:key;
            ukey=ukey.length<=45?ukey:md5(ukey);
        }
        let _key='flashdata_'+this.uid+'_'+ukey;
        return {ukey:ukey,_key:_key};
    }
    //存储
    set(key,obj,expire=30){
        this._clearData();
        let nowTime=new Date().getTime();
        let k=this.getkey(key,nowTime);
        let data=JSON.stringify({'data':obj})+'|@-@|'+(nowTime+expire*1000);
        window.localStorage.setItem(k._key,data);
        return k.ukey;
    }
    //获取
    get(key){
        this._clearData();
        let k=this.getkey(key);
        let data=(window.localStorage.getItem(k._key)||'').split('|@-@|');
        return !data[0]?'':JSON.parse(data[0]).data;
    }
    //清理
    _clearData(){
        for (var i = 0; i < window.localStorage.length; i++) {
            var key = window.localStorage.key(i);
            if(key.indexOf('flashdata_')>=0){
                let data=window.localStorage.getItem(key).split('|@-@|');
                if(parseInt(data[1])<new Date().getTime()){
                    window.localStorage.removeItem(key);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/cache.js